import { defineStore } from "pinia";

export const useUserDataStore = defineStore({
  id: "userData",
  state: () => ({
    dataPegawai: {},
    loadingGetDetailPegawai: false,
    errorGetDetailPegawai: false,
    profile: {},
    loadingGetProfileUser: false,
    errorGetProfileUser: false,
    isRoleAsn: false,
  }),
  actions: {
    async getDetailPegawai() {
      this.loadingGetDetailPegawai = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          "/auth/pegawai/getDetail",
          "GET",
        );
        useUserDataStore().$patch((state) => {
          state.dataPegawai = response || {};
          state.isRoleAsn = ["PNS", "CPNS", "PPPK", "ASN", "NON-ASN"].includes(
            response.statusPegawai,
          );
        });
        localStorage.setItem("dataPegawai", JSON.stringify(response || {}));
        this.errorGetDetailPegawai = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetDetailPegawai = true;
        }
      } finally {
        this.loadingGetDetailPegawai = false;
      }
      if (!useUserDataStore().isRoleAsn) {
        useBelajarWajibStore().clearTokens();
        return navigateTo({ path: "/pembelajaran-wajib/login" });
      }
    },
    async getProfileUser() {
      this.loadingGetProfileUser = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          "/dashboard-profile/api/profile/getbyuser",
          "GET",
        );
        useUserDataStore().$patch((state) => {
          state.profile = response || {};
        });
        localStorage.setItem("profile", JSON.stringify(response || {}));
        this.errorGetProfileUser = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetProfileUser = true;
        }
      } finally {
        this.loadingGetProfileUser = false;
      }
    },
  },
});
